var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirm-sensitive-content-view',{attrs:{"hide":_vm.hideConfirm},on:{"confirm":_vm.confirm}})}
var staticRenderFns = []

export { render, staticRenderFns }